<div class="origin" cdkOverlayOrigin #origin="cdkOverlayOrigin"></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="16"
  [cdkConnectedOverlayPositions]="positions"
  cdkConnectedOverlayPanelClass="motn-datetime-picker-pane"
>
  <div class="datetime-range-picker-card" (motnClickOutsideService)="closed$.emit()" (motnEscapeKey)="closed$.emit()">

    <mat-calendar
      [selected]="selectedRange"
      [maxDate]="maxDate"
      [dateFilter]="dateFilter"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>

    <div class="time-section">
      <span class="time-label">From</span>
      <motn-time-picker
        [hour]="startTime.hour"
        [minute]="startTime.minute"
        [second]="startTime.second"
        [period]="startTime.period"
        [showSeconds]="true"
        (hourChange)="updateStartTime({hour: $event})"
        (minuteChange)="updateStartTime({minute: $event})"
        (secondChange)="updateStartTime({second: $event})"
        (periodChange)="updateStartTime({period: $event})"
      ></motn-time-picker>
    </div>

    <div class="time-section">
      <span class="time-label">To</span>
      <motn-time-picker
        [hour]="endTime.hour"
        [minute]="endTime.minute"
        [second]="endTime.second"
        [period]="endTime.period"
        [showSeconds]="true"
        (hourChange)="updateEndTime({hour: $event})"
        (minuteChange)="updateEndTime({minute: $event})"
        (secondChange)="updateEndTime({second: $event})"
        (periodChange)="updateEndTime({period: $event})"
      ></motn-time-picker>
    </div>

    <div class="actions">
      <button class="apply-btn" [disabled]="!canApply" (click)="onApply()">Apply</button>
    </div>

  </div>
</ng-template>
